import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Box, Container, withStyles } from '@material-ui/core';
import get from 'lodash/get';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import RichText from '../../../shared/RichText';
import BackgroundImage from '../../../shared/BackgroundImage';
import Button from '../../../shared/Button';
import Logo from '../../../navigation/Logo';
import { pushEvent } from '../../../../utils/analyticUtils';

const styles = theme => ({
  root: {
    position: 'fixed',
    zIndex: 10000,
  },
  pageWrapper: {
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  },
  ageVerification: {
    height: '100%',
    transform: 'translate(0, -80px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  logo: {
    padding: theme.spacing(3),
  },
  contentWrapper: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
    backgroundColor: '#dbdbdbd1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(3),
    },
  },
  btn: {
    minWidth: '120px',
    margin: theme.spacing(2, 1, 0),
    padding: theme.spacing(1, 1),
    fontSize: '1rem',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 3),
      fontSize: '1.125rem',
    },
  },
});
function AgeVerification({ classes, className, pageData, logo, ...otherProps }) {
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['user_age_verified']);
  const { t } = useTranslation();

  const content = get(pageData, 'mainTheme.ageVerificationPage.content');
  const image = get(pageData, 'mainTheme.ageVerificationPage.heroImage');
  const publicId = get(image, 'cloudinaryImage.0.public_id');
  const altText = get(image, 'imageAltText');

  const handleBtnYesClick = () => {
    setCookie('user_age_verified', 'yes', { path: '/', maxAge: 126144000 });
    pushEvent('ageVerificationPassed');
  };

  return (
    <Box className={clsx(classes.root, className)} {...otherProps}>
      <Box className={classes.pageWrapper}>
        <BackgroundImage altText={altText} publicId={publicId} />
        <Box className={classes.ageVerification}>
          <Logo pageData={pageData} imgSrc={logo} width="370" className={classes.logo} />
          <Container className={classes.contentWrapper}>
            <RichText textData={content} />
            <Box>
              <Button className={classes.btn} onClick={handleBtnYesClick}>
                {t('AgeVerification.label.yes')}
              </Button>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

AgeVerification.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  pageData: PropTypes.object,
  logo: PropTypes.string,
};

AgeVerification.defaultProps = {
  classes: {},
  className: null,
  pageData: null,
  logo: null,
};

export default withStyles(styles)(AgeVerification);
